import { NavLink, useLocation } from 'react-router-dom';
import { FaRegCalendarAlt, FaRegFileAlt } from "react-icons/fa";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAddressBook, faUser } from '@fortawesome/free-regular-svg-icons';
import { MdCurrencyExchange } from 'react-icons/md';

const BottomTabBar = () => {
    const location = useLocation();

    // Función para verificar si estamos en una ruta de perfil
    const isProfileRoute = () => {
        const profileRoutes = ['/perfil', '/ajustes', '/mi-descripcion', '/cuenta-bancaria', '/soporte'];
        return profileRoutes.includes(location.pathname);
    };

    // Función para aplicar estilos activos
    const getNavLinkStyle = (isActive) => ({
        ...styles.navItem,
        ...(isActive ? styles.activeNavItem : {})
    });

    const getMiddleNavLinkStyle = (isActive) => ({
        ...styles.middleNavItem,
        ...(isActive ? styles.activeNavItem : {})
    });

    // Función para obtener el estilo del icono según si está activo
    const getIconStyle = (isActive) => ({
        width: '20px',
        height: '20px',
        filter: isActive ? 'brightness(0) saturate(100%) invert(27%) sepia(96%) saturate(7500%) hue-rotate(200deg) brightness(91%) contrast(101%)' : 'brightness(0) saturate(100%) invert(40%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(100%) contrast(100%)'
    });

    return (
        <>
            <style>
                {`
                    * {
                        -webkit-tap-highlight-color: transparent;
                    }
                    button, a, img {
                        outline: none !important;
                        box-shadow: none !important;
                    }
                    button:focus, a:focus, img:focus {
                        outline: none !important;
                        box-shadow: none !important;
                    }
                `}
            </style>
            <div style={styles.tabBarContainer}>
            <NavLink 
                    to="/subir-comprobante" 
                    style={({ isActive }) => getNavLinkStyle(isActive)}
                >
                    <FaRegFileAlt 
                        style={getIconStyle(location.pathname === "/subir-comprobante")} 
                        alt="Facturas"
                    />
                    <div style={styles.iconText}>Facturas</div>
                </NavLink>
               
                <NavLink 
                    to="/honorarios" 
                    style={({ isActive }) => getNavLinkStyle(isActive)}
                >
                    <MdCurrencyExchange 
                        style={getIconStyle(location.pathname === "/honorarios")} 
                        alt="Honorarios"
                    />
                    <div style={styles.iconText}>Honorarios</div>
                </NavLink>
                <NavLink 
                    to="/disponibilidad" 
                    style={({ isActive }) => getMiddleNavLinkStyle(isActive)}
                >
                    <div style={styles.middleButtonContainer}>
                        <div style={{
                            ...styles.middleButton,
                            backgroundColor: location.pathname === "/disponibilidad" ? '#1F85F6' : '#1F85F6', // cambiar el ultimo para cuando esté inactivo
                            border: 'none',
                            boxShadow: location.pathname === "/disponibilidad" ? '0px 5px 15px rgba(0, 0, 0, 0.3)' : '0px 2px 8px rgba(0, 0, 0, 0.1)',
                            //borderColor: '#fff', 
                        }}>
                            <FaRegCalendarAlt 
                                style={{ 
                                    ...styles.icon, 
                                    width: 22, 
                                    height: 22, 
                                    filter: 'brightness(0) saturate(100%) invert(100%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(100%) contrast(100%)'
                                }} 
                                alt="Disponibilidad"
                            />
                        </div>
                        <div style={{
                            ...styles.middleButtonText,
                            color: location.pathname === "/disponibilidad" ? '#1F85F6' : '#666666'
                        }}>Horarios</div>
                    </div>
                </NavLink>
 



                <NavLink 
                    to="/ver-disponibilidad" 
                    style={({ isActive }) => getNavLinkStyle(isActive)}
                >
                    <FontAwesomeIcon 
                        icon={faAddressBook} 
                        style={getIconStyle(location.pathname === "/ver-disponibilidad")} 
                        alt="Consultas"
                    />
                    <div style={styles.iconText}>Consultas</div>
                </NavLink>


                <NavLink 
                    to="/perfil" 
                    style={({ isActive }) => getNavLinkStyle(isActive || isProfileRoute())}
                >
                    <FontAwesomeIcon 
                        icon={faUser} 
                        style={getIconStyle(location.pathname === "/perfil" || isProfileRoute())} 
                        alt="Perfil"
                    />
                    <div style={{
                        ...styles.iconText,
                        color: isProfileRoute() ? '#1F85F6' : '#666666'
                    }}>Perfil</div>
                </NavLink>
            </div>
        </>
    );
};

const styles = {
tabBarContainer: {
    zIndex: 10,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    position: 'fixed',
    border: '1px solid',
    borderTopLeft: '0px',
    borderTopRight: '0px',
    borderColor: 'rgba(0,0,0,0.07)',
    bottom: 0,
    left: 0,
    right: 0,
    height: '80px',
    backgroundColor: '#fff',
    padding: '0 20px',
    boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)',
    borderTopLeftRadius: '30px',
    borderTopRightRadius: '30px',
},
    navItem: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        textDecoration: 'none',
        color: '#666666',
        flex: 1,
    },
    activeNavItem: {
        color: '#1F85F6',
    },
    middleNavItem: {
        position: 'relative', 
        top: '-22px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        color: '#e3e4e5',
        textDecoration: 'none',
        zIndex: 1,
    },
    middleButtonContainer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
    },
    middleButton: {
        width: '62px',
        height: '62px',
        borderRadius: '50%',
        justifyContent: 'center',
        alignItems: 'center',
        display: 'flex',
        boxShadow: '0px 5px 15px rgba(0, 0, 0, 0.1)',
      //  border: '3px solid',
    },
    middleButtonText: {
        fontSize: '11px',
        fontWeight: '800',
        marginTop: '6px',
        color: '#666666',
        textAlign: 'center',
    },
    iconText: {
        fontSize: '11px',
        fontWeight: '800',
        marginTop: '3px',
    },
    iconActive: {
        color: '#1F85F6',
    },
    icon: {
        outline: 'none',
        boxShadow: 'none',
    },
};

export default BottomTabBar;
